module.exports = __webpack_public_path__ + "customFactor_70x70.bd02d9064a3ef81834d8d9d5c3a49646.png";